import { CSSObject } from '@chakra-ui/react';

export const FlexResponsibleGamblingSlideContainer: CSSObject = {
  borderRadius: 'md',
};
